"use client";

import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { logger } from "@/lib/logger";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error("global error boundary", {
      error,
      digest: error.digest,
      boundary: "app/global-error",
    });
  }, [error]);

  return (
    <html lang="en">
      <body className="min-h-dvh bg-[radial-gradient(circle_at_top,rgba(194,65,12,0.18),transparent_38%),linear-gradient(180deg,#0c0a09_0%,#050403_100%)] text-white">
        <main className="flex min-h-dvh items-center justify-center p-6">
          <section
            data-liquid-glass="elevated"
            className="w-full max-w-lg rounded-[2rem] border p-8"
          >
            <p className="text-primary/80 text-sm uppercase tracking-display">
              Something went wrong
            </p>
            <h1 className="mt-4 text-3xl font-semibold tracking-tight">
              We couldn&apos;t load this page.
            </h1>
            <p className="text-white/72 mt-3 text-sm leading-6">
              Our team has been notified. Please try again, and contact support
              if the problem continues.
            </p>
            {error.digest ? (
              <p className="text-white/48 mt-5 text-xs tracking-display">
                Reference: {error.digest}
              </p>
            ) : null}
            <Button
              variant="ghost"
              className="border-primary/28 bg-primary/14 text-primary hover:bg-primary/20 hover:text-primary dark:hover:bg-primary/20 mt-8 h-11 rounded-full border px-5 transition"
              onClick={reset}
              type="button"
            >
              Try again
            </Button>
          </section>
        </main>
      </body>
    </html>
  );
}
